import { useState, useEffect } from 'react';
import { loadDemoStatuses } from '../demo/demoData';

function useAttackStatuses() {
  const [attackStatuses, setAttackStatuses] = useState({});
  const [userStatuses, setUserStatuses] = useState({});

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatuses = async () => {
    try {
      const data = await loadDemoStatuses('attacks');
      setAttackStatuses(data?.attackStatuses || {});
      setUserStatuses(data?.userStatuses || {});
    } catch (err) {
      setError('Failed to fetch attack statuses: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatuses();
  }, []);

  const updateStatus = async (attackName, enabled, userName = null) => {
    setLoading(true);
    try {
      if (userName) {
        setUserStatuses(prev => ({
          ...prev,
          [attackName]: {
            ...(prev[attackName] || {}),
            [userName]: { enabled }
          }
        }));
      } else {
        setAttackStatuses(prev => ({
          ...prev,
          [attackName]: { ...(prev[attackName] || {}), enabled }
        }));
      }
      return true;
    } catch (err) {
      setError(`Failed to ${enabled ? 'enable' : 'disable'} ${attackName}${userName ? ` for user ${userName}` : ''}: ${err.message}`);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { 
    attackStatuses,
    userStatuses,
    loading, 
    error, 
    updateStatus,
    refreshStatuses: fetchStatuses 
  };
}

export default useAttackStatuses; 